// Patient
export const SET_PATIENT = 'SET_PATIENT';
export const ADD_STUDY = 'ADD_STUDY';
export const SET_MAIN_STUDY_ID = 'SET_MAIN_STUDY_ID';
export const SET_DATA_RETRIEVED = 'SET_DATA_RETRIEVED';
export const SET_FETCHED_STUDIES = 'SET_FETCHED_STUDIES';

// Config
export const ADD_CONFIG = 'ADD_CONFIG';
export const ADD_TOKEN = 'ADD_TOKEN';
export const CHANGE_ANONYM = 'CHANGE_ANONYM';

// Layout
export const ADD_SELECTED_VIEW = 'ADD_SELECTED_VIEW';
export const REMOVE_SELECTED_VIEW = 'REMOVE_SELECTED_VIEW';
export const SET_VIEWS_GROUP = 'SET_VIEWS_GROUP';
export const SET_LAYOUT = 'SET_LAYOUT';
export const ADD_LAYOUT_ELEMENT = 'ADD_LAYOUT_ELEMENT';
export const CLEAR_ENABLED_ELEMENTS = 'CLEAR_ENABLED_ELEMENTS';
export const SELECT_ENABLED_ELEMENTS = 'SELECT_ENABLED_ELEMENTS';
export const SET_LAYOUT_ELEMENT = 'SET_LAYOUT_ELEMENT';
export const UPDATE_LAYOUT_ELEMENT = 'UPDATE_LAYOUT_ELEMENT';
export const SET_LAYOUT_ELEMENTS = 'SET_LAYOUT_ELEMENTS';
export const SET_CURRENT_VIEWMODE = 'SET_CURRENT_VIEWMODE';
export const SET_LAYOUT_GRID = 'SET_LAYOUT_GRID';
export const CHANGE_VIEW_SELECTED = 'CHANGE_VIEW_SELECTED';
export const SHOW_EXPLORER = 'SHOW_EXPLORER';
export const SHOW_HISTORY = 'SHOW_HISTORY';
export const SET_LAYOUT_ELEMENT_CAMERA = 'SET_LAYOUT_ELEMENT_CAMERA';
export const SET_REF_LINES = 'SET_REF_LINES';
export const SET_SCROLL_TYPE = 'SET_SCROLL_TYPE';
export const SET_CURRENT_TOOL = 'SET_CURRENT_TOOL';
export const SET_SYNCHED = 'SET_SYNCHED';
export const RESET_LAYOUT_STATE = 'RESET_LAYOUT_STATE';
export const RESET_LAYOUT_ELEMENT_STATE = 'RESET_LAYOUT_ELEMENT_STATE';
export const SET_IS_3D_MODE_ENABLED = 'SET_IS_3D_MODE_ENABLED';
export const SET_IS_MPR_MODE_ENABLED = 'SET_IS_MPR_MODE_ENABLED';

// StatusLayout
export const SET_STATUS_LAYOUT = 'SET_STATUS_LAYOUT';

// Wavefrom
export const SET_WAVEFORM_LAYOUT = 'SET_WAVEFORM_LAYOUT';
export const SET_WAVEFORM_VIEW_INDEX = 'SET_WAVEFORM_VIEW_INDEX';
export const SET_WAVEFORM_SCALE_FACTOR = 'SET_WAVEFORM_SCALE_FACTOR';
export const SET_WAVEFORM_TIME_FACTOR = 'SET_WAVEFORM_TIME_FACTOR';
export const SET_WAVEFORM_HTML_ELEMENT = 'SET_WAVEFORM_HTML_ELEMENT';

// Auth
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT = 'LOGOUT';

export const GETALL_REQUEST = 'GETALL_REQUEST';
export const GETALL_SUCCESS = 'GETALL_SUCCESS';
export const GETALL_FAILURE = 'GETALL_FAILURE';

export const DELETE_REQUEST = 'DELETE_REQUEST';
export const DELETE_SUCCESS = 'DELETE_SUCCESS';
export const DELETE_FAILURE = 'DELETE_FAILURE';

export const STUDY_PATHNAME = 'STUDY_PATHNAME';
export const SOCKET_STATE_CHANGE = 'SOCKET_STATE_CHANGE';
export const SOCKET_MESSAGE = 'SOCKET_MESSAGE';

// Alerts
export const SUCCESS = 'ALERT_SUCCESS';
export const ERROR = 'ALERT_ERROR';
export const CLEAR = 'ALERT_CLEAR';

// Manager
export const SET_STUDY_SEARCH_CONFIG = 'SET_STUDY_SEARCH_CONFIG';
export const SET_STUDIES_LIST = 'SET_STUDIES_LIST';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE';
export const SET_NEXT_PAGE_DISABLED = 'SET_NEXT_PAGE_DISABLED';
export const SET_TOTAL_STUDIES = 'SET_TOTAL_STUDIES';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_SELECTED_PACS_INDEX = 'SET_SELECTED_PACS_INDEX';
